import * as React from 'react';

import classnames from 'classnames';

import {MarketingTitle} from 'shells/typography/marketing-title';

import type {ExternalService} from 'nutshell-graphql-types';
import type {CalendarSync as CalendarSyncFragment} from 'nutshell-graphql-types';

import {Embedded} from '../../core/embedded';

import {CalendarOptionsRadioGroups} from './calendar-options-radio-groups';
import {ChangeCurrentCalendar} from './change-current-calendar';

import styles from './calendar-options.module.css';

type Props = {
    calendarSync: CalendarSyncFragment;
};

export const serviceNameMap: Partial<Record<ExternalService, string>> = {
    GOOGLE: 'Google',
    GOOGLE_APPS: 'Google', // To users it's just Google, the admin is likely the only one that knows it was set up with Google Apps
    OFFICE365: 'Office 365',
    EXCHANGE: 'Exchange',
    QUICKBOOKS: 'Quickbooks',
    DEMO: 'Demo',
};

/*
 * This shows and controls the sync options for a particular service provider (only one of which is allowed to be enabled)
 * These options include which activities should be synced to the external calendar, and which external calendar(s) should
 * be synced into Nutshell.
 */
export function CalendarOptions(props: Props) {
    const {isEnabled} = props.calendarSync;
    const selectedCalendar = props.calendarSync.calendars.find(
        (calendar) => calendar.syncType === 'PRIMARY'
    );
    const disabled = !isEnabled || !selectedCalendar;

    const disabledOverlayClass = classnames({
        [styles['disabled-overlay']]: !isEnabled,
        [styles['disabled-overlay--no-selected-calendar']]: !selectedCalendar && isEnabled,
    });

    return (
        <div className={styles['calendar-options']}>
            {/* @ts-expect-error */}
            <Embedded
                default={
                    <CalendarOptionsRadioGroups
                        calendarSync={props.calendarSync}
                        isDisabled={disabled}
                    />
                }
                embedded={
                    <>
                        {disabled ? <div className={disabledOverlayClass} /> : null}
                        <MarketingTitle>Which calendar would you like to use?</MarketingTitle>
                        <div className={styles['setting-section']}>
                            <ChangeCurrentCalendar calendarSync={props.calendarSync} />
                        </div>
                    </>
                }
            />
        </div>
    );
}
